module.exports = __webpack_public_path__ + "static/Slide4-75681408812166664a739237792547ae.jpg";